module.exports = __webpack_public_path__ + "static/media/noseSneerRight.4a901199.obj";